import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from "@mui/material";

import useTitle from "../hooks/useTitle";

import { Outlet } from "react-router-dom";

const IntrusctionsCard = () => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardHeader title="Instructions" />
      <CardContent>
        <Typography
          variant="body2"
          sx={{ fontWeight: 500, color: "text.secondary", mb: 1 }}
        >
          Use this page is to view and update Managed+ client specific Audience
          CPC floors only.
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontWeight: 400, color: "text.secondary" }}
        >
          1. Enter the required inputs below and click <b>‘Apply’</b> to view
          current rates.
          <br />
          2. To modify rates, click <b>‘Update’</b> and adjust the first TOS
          value.
          <br />
          3. Click <b>‘Recalculate’</b> to preview how the updated rates will
          apply across the rest of the TOS.
          <br />
          4. Click <b>‘Confirm’</b> to apply the new rates or <b>‘Cancel’</b> to
          discard any changes.
        </Typography>
      </CardContent>
    </Card>
  );
};

const ManagedPlusCustomAudienceFloors = () => {
  useTitle("M+ Client Pricing");

  return (
    <>
      <Stack spacing={3} sx={{ width: "75vw" }}>
        <IntrusctionsCard />
        <Stack spacing={2}>
          <Outlet />
        </Stack>
      </Stack>
    </>
  );
};

export default ManagedPlusCustomAudienceFloors;
